import { ReactElement } from 'react'
import Spinner from '../Spinner'
import Tag from '../tags/Tag'
import { debug } from 'lib/logging'

type Props = {
  activityTags?: string[]
  workspaceId?: string
  isLoading?: boolean
}

/**
 * Component to render activity tags.
 * @Param activityTags. string array. Activity tags.
 * @Param workspaceId. Workspace id to query for tag color
 * @Param isLoading. Boolean
 * @returns
 */
export function ActivityTags({ activityTags, workspaceId, isLoading = false }: Props): ReactElement | null {
  debug(`activityTags`, `activity tags`, activityTags)

  return isLoading ? (
    <Spinner size={4} />
  ) : (
    <>
      {activityTags
        ? activityTags.map((tag, i) => (
            <Tag
              key={`${tag}-${i}`}
              workspaceId={workspaceId}
              model="activities"
              tag={tag}
              removeTag={() => {}}
              tagClassName="text-ui-xs leading-4"
              readOnly
            />
          ))
        : null}
    </>
  )
}
